import fpti from '../../instrumentation'

export const removeHeaderFooter = (document) => {
  try {
    const header = document.getElementById('merchantHeader')
    const footer = document.getElementById('merchantFooter')
    if (header) {
      header.style.display = 'none'
    }
    if (footer) {
      footer.style.display = 'none'
    }
  } catch (e) {
    fpti.logFPTIError(e, 'HEADER_FOOTER_REMOVAL_ERROR', e)
  }
}

export const errorSetter = (
  e,
  urlToken,
  merchantText,
  setCancelUrl,
  setMerchantName,
) => {
  fpti.logFPTIError(e, e.error.error_code, e)
  if (e.error?.cancelUrl) {
    setCancelUrl(`${e.error?.cancelUrl}?token=${urlToken}`)
  }
  if (!e.error?.merchantName) {
    setMerchantName(merchantText)
  } else {
    setMerchantName(e.error.merchantName)
  }
}

export const extractTokenFromUrl = (window) => {
  try {
    const search = new URLSearchParams(window.location.search)
    return search.get('token')
  } catch (e) {
    fpti.logFPTIError(e, 'EXTRACT_TOKEN_FROM_URL_ERROR', e)
    return null
  }
}

export const extractTokenAndMerchantUrlFromUrl = (window) => {
  try {
    const search = new URLSearchParams(window.location.search)
    const token = search.get('token')
    const merchantUrl = search.get('merchantUrl')
    return { token, merchantUrl }
  } catch (e) {
    fpti.logFPTIError(e, 'EXTRACT_TOKEN_AND_MERCHANTURL_FROM_URL_ERROR', e)
    return { token: null, merchantUrl: null }
  }
}
